module.exports = __webpack_public_path__ + "img/dot-red.e64d7b04.svg";